export default "__VITE_ASSET__2f8119e2__"